import React from 'react';

function LoadingSpinner() {
  return (
    <div>
      <img src={`images/site/LoadingLine.gif`} alt="Loading Spinner" />
    </div>
  );
}
export default LoadingSpinner;
